export default "__VITE_ASSET__04a6951f__"